import SearchBox from './SearchBoxContainer';

export default SearchBox


